var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.active] = _vm.active, _class),
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.content
  }, [_vm.$slots.hasOwnProperty('icon') ? _c('div', {
    class: _vm.$style.icon
  }, [_vm._t("icon")], 2) : _vm._e(), _c('div', {
    class: _vm.$style.info
  }, [_vm.$slots.hasOwnProperty('title') ? _c('div', {
    class: _vm.$style.title
  }, [_vm._t("title")], 2) : _vm._e(), _vm.$slots.hasOwnProperty('description') ? _c('div', {
    class: _vm.$style.description
  }, [_vm._t("description")], 2) : _vm._e()]), _vm.$slots.hasOwnProperty('action') ? _c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "mobile",
      fn: function fn() {
        return [_c('div')];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', {
          class: _vm.$style.action
        }, [_vm._t("action")], 2)];
      },
      proxy: true
    }], null, true)
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }